import { NavLink } from 'react-router-dom'

import {
  ArrowUpRightIcon,
  Button,
  Card,
  Flex,
  Heading,
  Text,
} from '@buffer-mono/popcorn'

import styles from './ConnectAgentCard.module.css'

import type { JSX } from 'react'

export function ConnectAgentCard(): JSX.Element {
  return (
    <Card className={styles.card}>
      <Flex direction="column" gap="md">
        <Flex direction="column" gap="2xs">
          <Heading as="h3" size="xsmall">
            Connect an Agent
          </Heading>

          <Text color="subtle">
            Set up Claude, Cursor, and more from the Integrations page.
          </Text>
        </Flex>

        <Button
          as={NavLink}
          to="/settings/integrations"
          variant="secondary"
          size="large"
        >
          Browse Integrations
          <ArrowUpRightIcon />
        </Button>
      </Flex>
    </Card>
  )
}
